/**
 *  [2022] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */


/**
 * :ZNOTE:
 * tag: sleep
 * note:
 *  - 便利機能集だが、今のところsleep関数しかない
 * sample:
 *  -
 * :ZNOTE:
 */

const sleep = (ms: number) =>
  new Promise( (resolve: any) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });

// list関連の候補値(options)には配列の場合と、配列を取得する関数の場合があり、それの違いを吸収して候補値のlistを返す
const pickOptions = (options) : any => {
  const ret = (options && typeof options === 'function') ? options() : options;
  return ret;
};

export {sleep, pickOptions};
